export default [
  {
    path: 'account/info',
    name: 'Account Info',
    component: () => import('@/views/account/information/index.vue'),
    meta: {
      icon: 'icon-account',
      resourceCode: 'account:info',
    },
  },
  {
    path: 'account/permission',
    name: 'Account Permission',
    redirect: '/account/permission/role',
    meta: {
      icon: 'icon-account',
      resourceCode: 'account:permission',
      permissionType: 'menu', // 权限管理从listMenus列表里获取
      checkAuditStatus: true,
    },
  },
  {
    path: '/account/permission/role',
    name: 'Role Management',
    component: () => import('@/views/account/permission/role/index.vue'),
    meta: {
      resourceCode: 'account:permission:role',
      activeMenu: '/account/permission',
      parentPermissionType: 'menu',
      checkAuditStatus: true,
    },
  },
  {
    path: '/account/permission/operator',
    name: 'Operator Management',
    component: () => import('@/views/account/permission/operator/index.vue'),
    meta: {
      resourceCode: 'account:permission:operator',
      activeMenu: '/account/permission',
      parentPermissionType: 'menu',
      checkAuditStatus: true,
    },
  },
  {
    path: 'account/permission/role/view',
    name: 'Role Detail',
    component: () => import('@/views/account/permission/role/detail/index.vue'),
    meta: {
      activeMenu: '/account/permission',
      name: 'message.permission.roleDetails',
    },
  },
  // {
  //   path: 'account/password/edit',
  //   name: 'Edit Password',
  //   component: () => import('@/views/account/password-edit'),
  //   meta: {
  //     resourceCode: 'account:passwordEdit',
  //   },
  // },
  {
    path: 'account/password/edit',
    name: 'Edit Password',
    component: () => import('@/views/account/password-edit'),
    meta: {
      resourceCode: 'account:passwordEdit',
      hideMenu: true,
    },
  },
  {
    path: 'account/supplement', // 完善信息
    name: 'Register Supplement',
    component: () => import('@/views/account/information/supplement/index.vue'),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: 'account/supplement/done', // 完善信息
    name: 'Register Supplement Done',
    component: () => import('@/views/account/information/supplement/done.vue'),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: 'account/supplement/payout', // payout 商户完善信息
    name: 'Register Payout Supplement',
    component: () => import('@/views/account/information/supplement/payout.vue'),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: 'account/supplement/jumio', // payout 商户完善信息
    name: 'jumio',
    component: () => import('@/views/account/information/supplement/jumio.vue'),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: 'account/switch', // 账号切换
    name: 'Account Switch',
    component: () => import('@/views/account/switch/index.vue'),
    meta: {
      hideMenu: true,
    },
  },
  {
    path: 'account/security',
    name: 'Account Security',
    redirect: 'account/security/payment',
    meta: {
      icon: 'icon-account',
      resourceCode: 'account:security',
      checkAuditStatus: true,
    },
  },
  {
    path: 'account/security/payment',
    name: 'Account Security Payment',
    component: () => import('@/views/account/security/index.vue'),
    meta: {
      icon: 'icon-account',
      resourceCode: 'account:security:payment',
      activeMenu: '/account/security',
      checkAuditStatus: true,
    },
  },
  {
    path: 'account/security/sms',
    name: 'Account Security/sms',
    component: () => import('@/views/account/security/sms/index.vue'),
    meta: {
      icon: 'icon-account',
      resourceCode: 'account:security:sms',
      activeMenu: '/account/security',
      checkAuditStatus: true,
    },
  },
];
